import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import RequirePublicAccess from "../Components/RequirePublicAccess/RequirePublicAccess";
import RequireAuth from "../Components/RequireAuth/RequireAuth";
import RequireAdmin from "../Components/RequireAdmin/RequireAdmin";
import RequireOperator from "../Components/RequireOperator/RequireOperator";
import UserHomePage from "../Pages/Public/UserHomePage/UserHomePage";
import UserCompanyPage from "../Pages/Public/UserCompanyPage/UserCompanyPage";
import UserSignInPage from "../Pages/Public/UserSignInPage/UserSignInPage";
import UserSignUpPage from "../Pages/Public/UserSignUpPage/UserSignUpPage";
import UserResetPasswordPage from "../Pages/Public/UserResetPasswordPage/UserResetPasswordPage";
import UserProductPage from "../Pages/Public/UserProductPage/UserProductPage";
import UserProductDetailsPage from "../Pages/Public/UserProductDetailsPage/UserProductDetailsPage";
import UserTechnicalAssistancePage from "../Pages/Public/UserTechnicalAssistancePage/UserTechnicalAssistancePage";
import UserContactPage from "../Pages/Public/UserContactPage/UserContactPage";
import UserPoliciesPage from "../Pages/Public/UserPoliciesPage/UserPoliciesPage";
import UserPrivacyPoliciesPage from "../Pages/Public/UserPrivacyPoliciesPage/UserPrivacyPoliciesPage";
import UserExchangePoliciesPage from "../Pages/Public/UserExchangePoliciesPage/UserExchangePoliciesPage";
import UserCookiesPoliciesPage from "../Pages/Public/UserCookiesPoliciesPage/UserCookiesPoliciesPage";
import UserFaqPage from "../Pages/Public/UserFaqPage/UserFaqPage";
import UserPrivacyPortalPage from "../Pages/Public/UserPrivacyPortalPage/UserPrivacyPortalPage";
import UserDataPage from "../Pages/Public/UserDataPage/UserDataPage";
import AdminHomePage from "../Pages/Admin/AdminHomePage/AdminHomePage";
import AdminProductPage from "../Pages/Admin/AdminProductPage/AdminProductPage";
import AdminProductImportPage from "../Pages/Admin/AdminProductImportPage/AdminProductImportPage";
import AdminOperatorPage from "../Pages/Admin/AdminOperatorPage/AdminOperatorPage";
import AdminProductBrandPage from "../Pages/Admin/AdminProductBrandPage/AdminProductBrandPage";
import AdminProductCategoryPage from "../Pages/Admin/AdminProductCategoryPage/AdminProductCategoryPage";
import AdminProductModelPage from "../Pages/Admin/AdminProductModelPage/AdminProductModelPage";
import AdminCouponPage from "../Pages/Admin/AdminCouponPage/AdminCouponPage";
import AdminCustomerPage from "../Pages/Admin/AdminCustomerPage/AdminCustomerPage";
import AdminCustomerDetailsPage from "../Pages/Admin/AdminCustomerDetailsPage/AdminCustomerDetailsPage";
import AdminCustomerImportPage from "../Pages/Admin/AdminCustomerImportPage/AdminCustomerImportPage";
import AdminOrderPage from "../Pages/Admin/AdminOrderPage/AdminOrderPage";
import AdminBillingPage from "../Pages/Admin/AdminBillingPage/AdminBillingPage";
import AdminInStoreOrderPage from "../Pages/Admin/AdminInStoreOrderPage/AdminInStoreOrderPage";
import AdminInStoreOrderNewPage from "../Pages/Admin/AdminInStoreOrderPage/AdminInStoreOrderNewPage";
import UserCartPage from "../Pages/Public/UserCartPage/UserCartPage";
import UserOrderPage from "../Pages/Public/UserOrderPage/UserOrderPage";
import UserOrderDetailsPage from "../Pages/Public/UserOrderDetailsPage/UserOrderDetailsPage";
import UserCompleteOrderPage from "../Pages/Public/UserCompleteOrderPage/UserCompleteOrderPage";
import UserCompleteRegistrationPage from "../Pages/Public/UserCompleteRegistrationPage/UserCompleteRegistrationPage";
import AdminWhatsAppPage from "../Pages/Admin/AdminWhatsAppPage/AdminWhatsAppPage";
import OperatorHomePage from "../Pages/Operator/OperatorHomePage/OperatorHomePage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RequirePublicAccess />,
    children: [
      {
        path: "/",
        element: <App />,
        children: [
          { path: "", element: <UserHomePage /> },
          { path: "sobre", element: <UserCompanyPage /> },
          { path: "login", element: <UserSignInPage /> },
          { path: "cadastro", element: <UserSignUpPage /> },
          { path: "recuperar-senha", element: <UserResetPasswordPage /> },
          { path: "produtos", element: <UserProductPage /> },
          { path: "produtos/:id", element: <UserProductDetailsPage /> },
          { path: "assistencia-tecnica", element: <UserTechnicalAssistancePage /> },
          { path: "contato", element: <UserContactPage /> },
          { path: "politicas", element: <UserPoliciesPage /> },
          { path: "politica-privacidade", element: <UserPrivacyPoliciesPage /> },
          { path: "politica-trocas", element: <UserExchangePoliciesPage /> },
          { path: "politica-cookies", element: <UserCookiesPoliciesPage /> },
          { path: "faq", element: <UserFaqPage /> },
          { path: "portal-privacidade", element: <UserPrivacyPortalPage /> },
          { path: "carrinho", element: <UserCartPage /> },
          {
            element: <RequireAuth />,
            children: [
              { path: "meus-dados", element: <UserDataPage /> },
              { path: "pedidos", element: <UserOrderPage /> },
              { path: "pedidos/:id", element: <UserOrderDetailsPage /> },
              { path: "pedidos/concluir/:id", element: <UserCompleteOrderPage /> },
              { path: "completar-pedido/:id", element: <UserCompleteOrderPage /> },
              { path: "completar-cadastro", element: <UserCompleteRegistrationPage /> }
            ]
          }
        ]
      }
    ]
  },
  {
    path: "/admin",
    element: <RequireAdmin />,
    children: [
      { path: "", element: <AdminHomePage /> },
      { path: "produtos", element: <AdminProductPage /> },
      { path: "produtos/importar", element: <AdminProductImportPage /> },
      { path: "operadores", element: <AdminOperatorPage /> },
      { path: "marcas", element: <AdminProductBrandPage /> },
      { path: "categorias", element: <AdminProductCategoryPage /> },
      { path: "modelos", element: <AdminProductModelPage /> },
      { path: "cupons", element: <AdminCouponPage /> },
      { path: "clientes", element: <AdminCustomerPage /> },
      { path: "clientes/importar", element: <AdminCustomerImportPage /> },
      { path: "clientes/:id", element: <AdminCustomerDetailsPage /> },
      { path: "pedidos", element: <AdminOrderPage /> },
      { path: "pedidos/:id", element: <UserOrderDetailsPage /> },
      { path: "whatsapp", element: <AdminWhatsAppPage /> },
      { path: "faturamento", element: <AdminBillingPage /> },
      { path: "balcao", element: <AdminInStoreOrderPage /> },
      { path: "balcao/novo", element: <AdminInStoreOrderNewPage /> },
    ]
  },
  {
    path: "/operador",
    element: <RequireOperator />,
    children: [
      { path: "", element: <OperatorHomePage /> },
      { path: "clientes", element: <AdminCustomerPage /> },
      { path: "clientes/:id", element: <AdminCustomerDetailsPage /> },
      { path: "pedidos", element: <AdminOrderPage /> },
      { path: "pedidos/:id", element: <UserOrderDetailsPage /> },
      { path: "whatsapp", element: <AdminWhatsAppPage /> },
      { path: "balcao", element: <AdminInStoreOrderPage /> },
      { path: "balcao/novo", element: <AdminInStoreOrderNewPage /> },
    ]
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);
